import Tasks from "../components/Tasks/Tasks";
import Task from "../components/Tasks/Task";
import {PERM} from "../utilites/permissions";

const tasks = [
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    meta: {requiresAuth: true,
      permissions: [
        PERM.TASK,
        PERM.TASK_READ,
      ]
    },
    props: true,
  },
  {
    path: '/tasks/new',
    name: 'TasksAdd',
    component: Task,
    meta: {requiresAuth: true,
      permissions: [
        PERM.TASK,
        PERM.TASK_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/tasks/edit/:task_id',
    name: 'TasksEdit',
    component: Task,
    meta: {requiresAuth: true,
      permissions: [
        PERM.TASK,
        PERM.TASK_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/tasks/view/:task_id',
    name: 'TasksView',
    component: Task,
    meta: {requiresAuth: true,
      permissions: [
        PERM.TASK,
        PERM.TASK_READ,
      ]
    },
    props: true
  },
  {
    path: '/tasks/copy/:task_id',
    name: 'TasksCopy',
    component: Task,
    meta: {requiresAuth: true,
      isCopy: true,
      permissions: [
        PERM.TASK,
        PERM.TASK_EDIT,
      ]
    },
    props: true
  },
];

export default tasks;



// WEBPACK FOOTER //
// ./src/router/tasks.js